export const RoutePutMerchflows_MerchflowId_StoresApprovals =
  "/merchflows/:merchflowId/stores/approvals";

export interface Approval {
  store_pog_id: number;
}

export interface StoreApprovalFilters {
  store_pog_trigger_id?: number;
  storeCode?: string;
}

export type PayloadPutMerchflows_MerchflowId_StoresApprovals =
  | { approved: Approval[] }
  | { unapproved: Approval[] }
  | { approveAllExclude: Approval[]; filters?: StoreApprovalFilters }
  | { unapproveAllExclude: Approval[]; filters?: StoreApprovalFilters };
